/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_4_ProblemInputs */

const et_portfolio_project_4_problem = /** @type {(inputs: Portfolio_Project_4_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugev müük sotsiaalmeedias, kuid Google'is nähtamatu – kõrge ostukavatsusega kohalikud kliendid jäid leidmata.`)
};

const en_portfolio_project_4_problem = /** @type {(inputs: Portfolio_Project_4_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong social media sales but invisible on Google, missing high-intent local customers.`)
};

/**
* | output |
* | --- |
* | "Strong social media sales but invisible on Google, missing high-intent local customers." |
*
* @param {Portfolio_Project_4_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_4_problem = /** @type {((inputs?: Portfolio_Project_4_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_4_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_4_problem(inputs)
	return en_portfolio_project_4_problem(inputs)
});